import MODULE_ID from './moduleId';
import index from './index';
import dateUtils from "@/common/dateUtils";

// Components
import TelemetrieHeader from './components/TelemetrieHeader.vue';
import Telemetrie from './views/Telemetrie.vue';

class TelemetrieRouteHandler {
  getRoutes = ({ moduleType }) => {
    const initiateSyncBeforeNav = true;

    return [
      {
        path: `/${index.path}/:date?`,
        name: 'telemetrie-single-date',
        meta: {
          moduleType,
          initiateSyncBeforeNav: initiateSyncBeforeNav,
          MODULE_ID,
          baseRoute: true,
        },
        components: { default: Telemetrie, header: TelemetrieHeader },
      },
      {
        path: `/${index.path}/from/:from/to/:to`,
        name: 'telemetrie-range-date',
        beforeEnter(to, from, next) {
          const fromDate = to.params.from;
          const toDate = to.params.to;
          if (dateUtils.isValidYYYYMMDD(fromDate) && dateUtils.isValidYYYYMMDD(toDate)) {
            next();
          } else {
            next(`/${index.path}`);
          }
        },
        meta: {
          moduleType,
          initiateSyncBeforeNav: initiateSyncBeforeNav,
          MODULE_ID,
          baseRoute: true,
        },
        components: { default: Telemetrie, header: TelemetrieHeader },
      },
    ];
  };
}

export default new TelemetrieRouteHandler();
